import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import { ErrorBoundary, NotFoundPage } from '@rehome/shared';

/**
 * ReHome Landing App (rehome.hu)
 *
 * Single-page public-facing site:
 * - Hero slider, animal spotlights, urgent campaign previews
 * - Navigation to the Platform (app.rehome.hu) and Admin (admin.rehome.hu)
 */
const App: React.FC = () => {
  return (
    <ErrorBoundary>
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </ErrorBoundary>
  );
};

export default App;
